import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { SubscriptionPlan } from '@vi-iot/client';

import {
  BookingStore,
  BookingSubscription,
  BOOKING_SUBSCRIPTIONS_FILTER_TYPE,
  UserDetailsStore,
} from '@store';
import { ViPanelComponent } from '@vi-iot/ui/index';
import { ChipFiltersComponent } from 'src/app/shared/components/chip-filters/chip-filters.component';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlatRateRowComponent } from '../flat-rate-row/flat-rate-row.component';
import { ChipFilterComponent } from './../../../../shared/components/chip-filters/chip-filter/chip-filter.component';
import { SortBookingsPipe } from '../sort-bookings.pipe';
import { PackagePerInstallationRowComponent } from '../package-per-installation-row/package-per-installation-row.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-flat-rate-bookings',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    SortBookingsPipe,
    ViPanelComponent,
    ChipFiltersComponent,
    ChipFilterComponent,
    MatCheckboxModule,
    ScrollingModule,
    FlatRateRowComponent,
    PackagePerInstallationRowComponent,
  ],
  templateUrl: './flat-rate-bookings.component.html',
  styleUrls: ['./flat-rate-bookings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatRateBookingsComponent implements OnInit {
  @Input() subscriptions: BookingSubscription[];

  readonly subscriptionsFilterType = BOOKING_SUBSCRIPTIONS_FILTER_TYPE;
  readonly numberOfFlatRateRowsWithoutScrollbar: number = 4;
  readonly numberOfTrialRowsWithoutScrollbar: number = 2;

  activeSubscriptionsFilter: BOOKING_SUBSCRIPTIONS_FILTER_TYPE =
    BOOKING_SUBSCRIPTIONS_FILTER_TYPE.PRO;
  flatRateSubscriptions: BookingSubscription[] = [];
  trialSubscriptions: BookingSubscription[] = [];

  constructor(public bookingStore: BookingStore, public userDetailsStore: UserDetailsStore) {}

  ngOnInit(): void {
    this.filterSubscriptions();
  }

  private filterSubscriptions(): void {
    this.subscriptions.forEach((entry) => {
      if (!entry.trial && entry.plan === SubscriptionPlan.Pro) {
        this.flatRateSubscriptions.push(entry);
      }
      if (entry.trial && entry.plan === SubscriptionPlan.Pro) {
        this.trialSubscriptions.push(entry);
      }
    });
  }

  setFilter(subscriptionFilter: BOOKING_SUBSCRIPTIONS_FILTER_TYPE): void {
    this.activeSubscriptionsFilter = subscriptionFilter;
  }
}
